import { FilterOutlined, PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { Col, Dropdown, Input, Row } from 'antd';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from '@lib/common';
import { styleVariables } from '@lib/common';
import { FilterForm } from '../filter-form-assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledFunctionBar = styled(Row).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledFunctionBar",
  componentId: "sc-1b64t6g-0"
})(["margin-bottom:25px;"]);
var StyledFilterContainer = styled(Row).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledFilterContainer",
  componentId: "sc-1b64t6g-1"
})(["margin-bottom:32px;"]);
var StyledFilterGroup = styled(Col).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledFilterGroup",
  componentId: "sc-1b64t6g-2"
})(["color:", ";text-align:end;align-self:center;button{font-size:18px;padding:0px;}"], styleVariables.colors.blue4);
var FilterButton = styled(SecondaryButton).withConfig({
  displayName: "list-assignment-layoutcomponent__FilterButton",
  componentId: "sc-1b64t6g-3"
})(["font-size:16px !important;padding:0px 10px !important;"]);
var AddNewText = styled.span.withConfig({
  displayName: "list-assignment-layoutcomponent__AddNewText",
  componentId: "sc-1b64t6g-4"
})(["font-weight:600;font-size:24px;margin-right:25px;"]);
var StyledListAssignment = styled(Row).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledListAssignment",
  componentId: "sc-1b64t6g-5"
})(["justify-content:", ";"], function (_ref) {
  var justifyContent = _ref.justifyContent;
  return justifyContent;
});
var StyledFilterItems = styled(Row).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledFilterItems",
  componentId: "sc-1b64t6g-6"
})([""]);
var StyledReloadOutlined = styled(ReloadOutlined).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledReloadOutlined",
  componentId: "sc-1b64t6g-7"
})(["text-align:center;font-size:16px;padding:0 15px;color:", ";"], styleVariables.colors.blue4);
var StyledPrimaryButton = styled(PrimaryButton).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledPrimaryButton",
  componentId: "sc-1b64t6g-8"
})(["margin-right:20px;"]);
var StyledSearch = styled.div.withConfig({
  displayName: "list-assignment-layoutcomponent__StyledSearch",
  componentId: "sc-1b64t6g-9"
})(["margin-right:20px;"]);
var StyledFilterButton = styled(FilterButton).withConfig({
  displayName: "list-assignment-layoutcomponent__StyledFilterButton",
  componentId: "sc-1b64t6g-10"
})(["margin-right:20px;"]);
export var ListAssignment = function ListAssignment(_ref2) {
  var handleSearch = _ref2.handleSearch,
      translation = _ref2.translation,
      isLoadingList = _ref2.isLoadingList,
      isReloading = _ref2.isReloading,
      handleReload = _ref2.handleReload,
      handleVisibleModal = _ref2.handleVisibleModal,
      _ref2$justifyContent = _ref2.justifyContent,
      justifyContent = _ref2$justifyContent === void 0 ? 'center' : _ref2$justifyContent,
      assignmentConfigs = _ref2.assignmentConfigs,
      handleFilter = _ref2.handleFilter,
      handleClearFilter = _ref2.handleClearFilter,
      children = _ref2.children;
  return /*#__PURE__*/_jsx(StyledListAssignment, {
    justifyContent: justifyContent,
    children: /*#__PURE__*/_jsxs(Col, {
      span: 24,
      children: [/*#__PURE__*/_jsx(StyledFunctionBar, {
        children: typeof handleVisibleModal === 'function' ? /*#__PURE__*/_jsxs(Col, {
          span: 14,
          children: [/*#__PURE__*/_jsx(AddNewText, {
            children: translation('assignQuiz')
          }), /*#__PURE__*/_jsxs(StyledPrimaryButton, {
            onClick: handleVisibleModal,
            children: [/*#__PURE__*/_jsx(PlusCircleOutlined, {}), translation('addNewExercise')]
          })]
        }) : /*#__PURE__*/_jsx("div", {})
      }), /*#__PURE__*/_jsx(StyledFilterContainer, {
        children: /*#__PURE__*/_jsx(StyledFilterGroup, {
          span: 24,
          children: /*#__PURE__*/_jsxs(StyledFilterItems, {
            children: [/*#__PURE__*/_jsx(Col, {
              span: 8,
              children: /*#__PURE__*/_jsx(StyledSearch, {
                children: /*#__PURE__*/_jsx(Input.Search, {
                  placeholder: translation('searchExamExercise'),
                  allowClear: true,
                  onSearch: handleSearch,
                  onChange: function onChange(e) {
                    return handleSearch(e.target.value);
                  }
                })
              })
            }), typeof handleFilter === 'function' ? /*#__PURE__*/_jsx(Dropdown, {
              placement: "bottom",
              trigger: ['click'],
              arrow: {
                pointAtCenter: true
              },
              overlay: /*#__PURE__*/_jsx(FilterForm, {
                assignmentConfigs: assignmentConfigs,
                handleFilter: handleFilter,
                onReset: handleClearFilter,
                translation: translation
              }),
              children: /*#__PURE__*/_jsx(StyledFilterButton, {
                icon: /*#__PURE__*/_jsx(FilterOutlined, {}),
                children: "B\u1ED9 l\u1ECDc"
              })
            }) : /*#__PURE__*/_jsx("div", {}), typeof handleReload === 'function' ? /*#__PURE__*/_jsx(SecondaryButton, {
              disabled: isReloading && isLoadingList,
              children: /*#__PURE__*/_jsx(StyledReloadOutlined, {
                spin: isLoadingList && isReloading,
                onClick: handleReload
              })
            }) : /*#__PURE__*/_jsx("div", {})]
          })
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          span: 24,
          children: children
        })
      })]
    })
  });
};